// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pill[data-v-3ebbbb36]{display:inline-block;border-radius:11px;font-weight:600;padding:2px 8px 2px 8px;margin-right:6px;margin-bottom:3px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
